import React from 'react';
import { styled } from 'linaria/react';
import SectionWrapper from '../../../Layout/SectionWrapper';
import JournalCategory from './JournalCategory';
import MaxWidth from '../../../Layout/MaxWidth';

const Wrapper = styled(SectionWrapper)`
  display: flex;
  justify-content: center;
`;

const ContentWrapper = styled(MaxWidth)`
  .inner {
    display: grid;
    gap: 1rem;
    grid-auto-flow: column;
    overflow-x: auto;
    padding-left: 1em;

    &::after {
      content: '';
      width: 1.5rem;
    }
  }
`;

const JournalCategories = ({ categories }) => {
  const filteredCategories = categories?.filter(
    category => category.link && category.title
  );

  return (
    filteredCategories?.length > 0 && (
      <Wrapper>
        <ContentWrapper>
          <div className="inner">
            {filteredCategories.map(category => (
              <JournalCategory key={category.id} category={category} />
            ))}
          </div>
        </ContentWrapper>
      </Wrapper>
    )
  );
};

export default JournalCategories;
